import { gql } from 'graphql-request';

const sendCartLink = gql`
  mutation (
    $subdomain: String!
    $selectedOrderMode: String!
    $fulfillmentTimeType: JSON!
    $cartId: String!
    $selectedPaymentMethod: SelectedPaymentMethod!
    $operatorId: ID!
    $selectedUserCarId: ID
    $selectedArea: JSON
    $selectedCoordinates: JSON
    $supportedDeliveryZone: JSON
  ) {
    sendCartLink(
      subdomain: $subdomain
      selectedOrderMode: $selectedOrderMode
      fulfillmentTimeType: $fulfillmentTimeType
      cartId: $cartId
      selectedPaymentMethod: $selectedPaymentMethod
      operatorId: $operatorId
      selectedUserCarId: $selectedUserCarId
      selectedArea: $selectedArea
      selectedCoordinates: $selectedCoordinates
      supportedDeliveryZone: $supportedDeliveryZone
    ) {
      link
    }
  }
`;
export default sendCartLink;
